import React, { useState, useEffect, useRef } from "react";
import Header from "./Header.js";
import Footer from "./Footer.js";
import Select from "react-select";

import { TailSpin } from "react-loader-spinner";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./Style.css";
import "../../Api/apiUrls";
import Update_CustomerPayout from "../../Components/Admin_components/update_customerPayout.js";
import { getAdminCustomerPayout } from "../../Api/apiUrls";
function CustomerPayOut() {
  const [payout, setPayout] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [
    modalUpdate_CustomerPayoutIsOpen,
    setUpdate_CustomerPayoutModalIsOpen,
  ] = useState("");
  const [selectedAccountBalance, setSelectedAccountBalance] = useState(null);
  const [selectedPaymentDone, setSelectedPaymentDone] = useState(null);
  const [selectedPayoutStatus, setCustomerPayoutStatus] = useState(null);
  const [selectedPayoutId, setSelectedPayoutId] = useState(null);
  const openUpdate_customerPayout = (
    customerPayoutId,
    accountBalance,
    paymentDone,
    customerPayoutStatus
  ) => {
    setSelectedPayoutId(customerPayoutId);
    setSelectedAccountBalance(accountBalance);
    setSelectedPaymentDone(paymentDone);
    setCustomerPayoutStatus(customerPayoutStatus);

    closeUpdate_customerPayout();
    setUpdate_CustomerPayoutModalIsOpen(true);
  };

  const closeUpdate_customerPayout = () => {
    setUpdate_CustomerPayoutModalIsOpen(false);
  };
  useEffect(() => {
    fetch(getAdminCustomerPayout)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        const payout = data.data.CustomerPayOut;
        setPayout(payout);
        console.log(payout);
      })
      .catch((error) => console.error("Error fetching data:", error))
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  const [searchQuery, setSearchQuery] = useState("");
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };
  const filteredCustPayout = Array.isArray(payout)
    ? payout.filter((payout) => {
        const values = Object.values(payout).map((value) =>
          typeof value === "string" ? value.toLowerCase() : ""
        );
        const isSearchMatch = values.some((value) =>
          value.includes(searchQuery.toLowerCase())
        );
        return isSearchMatch;
      })
    : [];
  const formatCreatedAt = (createdAt) => {
    const createdAtDate = new Date(createdAt);
    return createdAtDate.toLocaleString("en-GB", {
      day: "numeric",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  };

  return (
    <div>
      <Header></Header>
      {modalUpdate_CustomerPayoutIsOpen && (
        <Update_CustomerPayout
          onClose={closeUpdate_customerPayout}
          customerPayoutId={selectedPayoutId}
          accountBalance={selectedAccountBalance}
          paymentDone={selectedPaymentDone}
          customerPayoutStatus={selectedPayoutStatus}
        />
      )}
      <main id="main" class="main">
        <div class="pagetitle">
          <h1>Customer PayOut</h1>
          {/*  */}
        </div>
        <section class="section">
          <div class="card p-2">
            <div class="parent col-md-12 row mt-2">
              <div class="col-md-6">
                <div class="child">
                  <input
                    id="myInput"
                    type="text"
                    style={{
                      borderRadius: "5px",
                      height: "35px",
                      padding: "10px",
                      border: "1px solid lightgrey ",
                    }}
                    onChange={handleSearchChange}
                    value={searchQuery}
                    placeholder="Search..."
                  />
                </div>
              </div>
            </div>

            <div
              style={{ marginTop: "50px", display: "flex", marginLeft: "50%" }}
            ></div>
            <div class="table-responsive">
              {isLoading === true ? (
                <div
                  style={{
                    marginTop: "50px",
                    display: "flex",
                    marginLeft: "50%",
                  }}
                >
                  <TailSpin color="black" width={50} />
                </div>
              ) : payout.length > 0 ? (
                <table class="table  table-striped ">
                  <thead>
                    <tr>
                      <th scope="col">Sr.No</th>
                      <th scope="col">Listing type</th>
                      <th scope="col">Listing Name</th>
                      <th scope="col">Listing Id</th>
                      <th scope="col">Customer Details </th>
                      <th scope="col">Bank details</th>
                      <th scope="col">Appointment Date/Time</th>
                      <th scope="col">Appointment Cancellation Date/Time</th>
                      <th scope="col">Amount Received</th>
                      <th scope="col">Transaction details</th>
                      <th scope="col">Account Balance</th>
                      <th scope="col">Reason for Cancellation</th>
                      <th scope="col">Payment Done</th>
                      <th scope="col">Payout Status</th>
                      <th scope="col">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredCustPayout.map((payout, index) => (
                      <tr key={payout.id}>
                        <th scope="row">{index + 1}</th>

                        <td>{payout.listing_type || "-"}</td>

                        <td>
                          {payout.venue
                            ? payout.venue.name || "-"
                            : payout.workshop
                            ? payout.workshop.name || "-"
                            : "-"}
                        </td>
                        <td> {payout.id}</td>
                        <td> {payout.user ? payout.user.name || "-" : "-"}</td>
                        <td>
                          <b>BankName:</b> {payout.user.bank_name || "-"}
                          <br />
                          <b>Acc No:</b>
                          {payout.user.bank_account_number || "-"}
                          <br />
                          <b>Ifsc Code:</b>
                          {payout.user.bank_ifsc_code || "-"}
                        </td>

                        <td>
                          {" "}
                          {payout.booking_slot
                            ? `${payout.booking_slot.startDate} ${payout.booking_slot.startTime}`
                            : payout.workshop_slot
                            ? payout.workshop_slot.date +
                              " " +
                              payout.workshop_slot.startTime
                            : "-"}{" "}
                        </td>
                        <td>{formatCreatedAt(payout.created_at || "-")}</td>
                        <td>{payout.transaction.amount || "-"}</td>
                        <td>
                          <b>OrderId:</b> {payout.transaction.order_id || "-"}
                          <br />
                          <b>PayId:</b> {payout.transaction.payment_id || "-"}
                        </td>
                        <td>{payout.account_balance || "-"}</td>
                        <td>
                          {payout.appointment.reasonOfCancellation || "-"}
                        </td>
                        <td>{payout.payment_done}</td>
                        <td>{payout.payout_status || "-"}</td>
                        <td>
                          <div className="social-links mt-2">
                            <a
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                openUpdate_customerPayout(
                                  payout.id,
                                  payout.account_balance,
                                  payout.payment_done,
                                  {
                                    value: payout.id,
                                    label: payout.payout_status,
                                  }
                                )
                              }
                            >
                              <i class="bi bi-pencil"></i>
                            </a>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <h3 style={{ textAlign: "center" }}> No data available </h3>
              )}
            </div>
          </div>
          <div>
            {" "}
            <p
              style={{
                backgroundColor: "#000",
                color: "white",
                padding: "10px",
              }}
            >
              {filteredCustPayout.length} Total
            </p>
          </div>
        </section>
      </main>
      <Footer></Footer>
    </div>
  );
}

export default CustomerPayOut;
